<template>
  <section class="shared-track" :aria-busy="String(shared.status==='loading')">
    <template v-if="shared.track">
      <img :src="cover" alt="" />
      <h1>{{ shared.track.title }}</h1><p>{{ shared.track.artists.join(' / ') }}</p>
    </template>
    <h1 v-else>分享歌曲</h1>
    <p role="status">{{ shared.status==='loading' ? '正在读取歌曲…' : shared.error }}</p>
    <div class="shared-actions">
      <component :is="salt ? 'SaltButton' : 'button'" v-if="shared.status==='error' || shared.status==='gesture'" :class="{'plain-button':!salt}" @click="load">{{ shared.status==='gesture' ? '点击播放' : '重试' }}</component>
      <component :is="salt ? 'SaltButton' : 'button'" v-if="canOpen" :class="{'plain-button':!salt}" style-type="subtle" @click="openPlayer">打开播放页</component>
      <router-link class="back-link" to="/">返回首页</router-link>
    </div>
  </section>
</template>
<script>
import { runtime } from '../bridge';
import { createSharedTrackSession } from '../share-track';
import { workspace } from '../workspace';
import SaltButton from '../salt/ui/SaltButton.vue';
export default {
  name:'SharedTrack', components:{SaltButton},
  data(){return{workspace,shared:{status:'loading',track:null,error:''}};},
  computed:{salt(){return this.workspace.appearance==='salt';},cover(){return runtime.cover(this.shared.track);},canOpen(){return this.shared.status!=='loading' && this.shared.track && runtime.state.currentId===this.shared.track.id;}},
  watch:{'$route.fullPath'(){this.load();}},
  created(){this._session=createSharedTrackSession(runtime,state=>{this.shared=state;});this.load();},
  beforeDestroy(){this._session.dispose();},
  methods:{load(){return this._session.load(this.$route.params.platform,this.$route.params.id);},openPlayer(){if(runtime.state.currentId===this.shared.track?.id)runtime.ui.lyricsOpen=true;else this.load();}},
};
</script>
<style scoped>
.shared-track { display:grid; justify-items:center; align-content:center; gap:12px; min-height:55vh; padding:24px; text-align:center; color:var(--salt-text,var(--color-text)); }
.shared-track img { width:min(240px,60vw); aspect-ratio:1; object-fit:cover; border-radius:var(--salt-large-radius,12px); }
.shared-track h1,.shared-track p { margin:0; overflow-wrap:anywhere; }
.shared-track h1 { font-size:24px; }.shared-track p { color:var(--salt-sub-text,var(--color-text-secondary)); }
.shared-actions { display:flex; flex-wrap:wrap; justify-content:center; align-items:center; gap:12px; }
.back-link { color:var(--salt-accent,var(--color-primary)); font-size:14px; }
</style>
